import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import { Input} from "reactstrap";
import Footer from "../../../GlobalComponents/Footer";
import Navbar from "../Navbar";
import { userActions } from "../../../../actions";

class EditProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            editUserData: {
                id: "",
                user_role: "",
                first_name: "",
                last_name: "",
                email: "",
                phone: ""
            },
            error: false,
            message:false
        };

        this.handleUpdate = this.handleUpdate.bind(this);
    }

    getUserData() {
        this.props.dispatch(userActions.getById(this.state.user.data._id));
    }

    editUserInfoHandler = (name, value) => {
        const { editUserData } = this.state;
        editUserData[name] = value;
        this.setState({
            editUserData
        });
    };

    handleUpdate() {   
        this.props.dispatch(userActions.updateUser(this.state.editUserData));
    }

    setEditUser(data) {
        console.log(data);
        this.setState({
            editUserData: {
                id:data._id,
                user_role: data.user_role,
                first_name: data.first_name,
                last_name:data.last_name,
                email: data.email,
                phone:data.phone,
                status: "Active"
            },
            message:false
        });
    }  

    componentDidMount(){
        this.getUserData();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log(nextProps);

        if(nextProps.editModal == true) {
            this.setEditUser(nextProps.user.data);
        }
        
        if(nextProps.editModal == false) {
            this.setState({ 
                message: true 
            });
        
            setTimeout(() => {
                this.setState({ 
                    message: false 
                });
            }, 5000);
        }
        

        if(nextProps.error !== "")
        {
            this.setState({ 
                error: true 
            });

           
        }
    }

    render() {
        //const { kitsList, productsList } = this.props;
        if (!this.state.user) {
            return <Redirect to="/" />;
        }
        if(this.state.user.data.user_role !== "reps") {
            return <Redirect to="/" />;
        }
        const { error } = this.props;
        
        return (
            <div>
                <Navbar />
                <section className="b-burger">
                    <div className="container"> 
                        {/* <h1 className="date-scroll pt-4"> <Link to="/reps/open-booking"><i className="fa fa-long-arrow-left smbtn"></i> <strong>Back</strong></Link></h1> */}
                        
                        <div className="row pt-4">
                            <div className="col-lg-8 offset-lg-2">
                                <div className="d-card">
                                    <h4>Edit Profile</h4>
                                    
                                    
                                    <div className="form-group">
                                        <label>First Name <strong className="text-danger">*</strong></label>
                                        <Input 
                                            type="text"
                                            className="form-control"
                                            value={this.state.editUserData.first_name} 
                                            onChange = {(e) => this.editUserInfoHandler("first_name", e.target.value)}
                                        />
                                        {(this.state.error && error) ? <span className="text-danger">{error.first_name ? error.first_name : ""}</span> : ""}
                                    </div>
                                    <div className="form-group">
                                        <label>Last Name <strong className="text-danger">*</strong></label>
                                        <Input 
                                            type="text"
                                            className="form-control"
                                            value={this.state.editUserData.last_name} 
                                            onChange = {(e) => this.editUserInfoHandler("last_name", e.target.value)}
                                        />
                                        {(this.state.error && error) ? <span className="text-danger">{error.last_name ? error.last_name : ""}</span> : ""}
                                    </div>
                                    <div className="form-group">
                                        <label>Email Address (Username) <strong className="text-danger">*</strong></label>
                                        <Input 
                                            type="email"
                                            className="form-control"
                                            value={this.state.editUserData.email} 
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Phone Number </label>
                                        <Input 
                                            type="number"
                                            min="0"
                                            className="form-control"
                                            value={this.state.editUserData.phone} 
                                            onChange = {(e) => this.editUserInfoHandler("phone", e.target.value)}
                                        />
                                        {(this.state.error && error) ? <span className="text-danger">{error.phone ? error.phone : ""}</span> : ""}
                                        { this.state.message==true && <span className="text-success">Profile updated successfully</span> }

                                    </div>
                                </div>
                                <div className="mt-5 text-right">
                                    <Link to="/reps/open-booking" className="btn btn-secondary mb-3 mr-2">Cancel</Link>
                                    <button className="btn btn-primary mb-3" onClick={this.handleUpdate}>Save Changes</button>
                                </div>   
                            </div>
                            <div className="col-lg-4"></div>
                        </div>
                        
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.rootReducer.users;
    const { error } = state.rootReducer.users;
    const { editModal } = state.rootReducer.users;
    
    return {
        error,
        editModal,
        user
    };
}

export default connect(mapStateToProps)(EditProfile);